import { gql } from '@apollo/client';

export const ADD_OPDS_ACCOUNT = gql`
  mutation AddOpdsAccount($input: OpdsAccountApiRequestInput!) {
    addOpdsAccount(input: $input) {
      success
      message
      messageCode
      data {
        id
      }
    }
  }
`;

export const UPDATE_OPDS_ACCOUNT = gql`
  mutation UpdateOpdsAccount($input: OpdsAccountApiRequestInput!) {
    updateOpdsAccount(input: $input) {
      success
      message
      messageCode
      data {
        id
      }
    }
  }
`;

export const DELETE_OPDS_ACCOUNT = gql`
  mutation DeleteOpdsAccount($input: DeleteByIdInput!) {
    deleteOpdsAccount(input: $input) {
      success
      message
      messageCode
    }
  }
`;

export interface OpdsAccountApiRequestInput {
  id?: number | null;
  email?: string | null;
  countryCode?: number | null;
  phone?: number | string | null;
  password?: string | null;
  name?: string | null;
  status?: number | null;
  deptIds?: number[];
  roleIds?: number[];
  /** Lark user_id；未填写传空字符串 '' */
  larkId?: string;
}
